




































import LazyHydrate from 'vue-lazy-hydration';

import { SfButton, SfImage, SfIcon } from '~/components';

import { ref, defineComponent, watch, computed, useContext } from '@nuxtjs/composition-api';
import StoresModal from '~/components/StoreSwitcher/StoresModal.vue';
import SfCharacteristic from '~/components/molecules/SfCharacteristic/SfCharacteristic.vue';
import { useConfig, useMagentoConfiguration, useWebsiteCode } from '~/composables';

export default defineComponent({
  name: 'StoreSwitcher',
  components: {
    StoresModal,
    SfButton,
    SfCharacteristic,
    SfImage,
    LazyHydrate,
    SfIcon
  },
  setup() {
    const { config } = useConfig();
    const { app } = useContext();
    const { isBy } = useWebsiteCode();

    const {
      selectedCurrency,
      selectedLocale,
    } = useMagentoConfiguration();

    const isLangModalOpen = ref(false);

    watch(isLangModalOpen, () => {
      isLangModalOpen.value
        ? document.body.style.overflow = "hidden"
        : document.body.style.overflow = "auto";
    })

    const defaultCountry = isBy.value ? 'Belarus' : 'Russia';
    const defaultCountryCode = isBy.value ? 'belarus' : 'russia';
    const cookieCountry = app.$cookies.get('vsf-selected-country');
    const cookieCountryCode = app.$cookies.get('vsf-selected-country-code');

    if (cookieCountry !== defaultCountry || cookieCountryCode !== defaultCountryCode) {
      app.$cookies.set('vsf-selected-country', defaultCountry);
      app.$cookies.set('vsf-selected-country-code', defaultCountryCode);
    }

    const getShipToCountryCode = computed(() => defaultCountryCode);
    const shipToCountry = computed(() => defaultCountry);

    return {
      selectedCurrency,
      selectedLocale,
      isLangModalOpen,
      storeConfig: config,
      shipToCountry,
      getShipToCountryCode,
    };
  },
});
